import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DISCORD_LINK } from '@core/constants/discord.constants';
import { SvgIconComponent } from 'angular-svg-icon';

interface Social {
  icon: string;
  name: string;
  link: string;
}

const SOCIALS: Social[] = [
  {
    icon: 'assets/icons/socials/twitter.svg',
    name: 'twitter',
    link: 'https://x.com/tf2hunt',
  },
  {
    icon: 'assets/icons/socials/discord.svg',
    name: 'discord',
    link: DISCORD_LINK
  },
];

@Component({
  selector: 'app-site-socials',
  imports: [SvgIconComponent],
  standalone: true,
  templateUrl: './site-socials.component.html',
  styleUrl: './site-socials.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiteSocialsComponent {
  socials = SOCIALS;
}
